<template>
  <div>
    <q-page class="container" padding>
      <PageHeader
        title="Lista de Ferramentas para Movimentação"
        :backRoute="{ name: 'home' }"
        backBehavior="route"
      />
      <div class="row col-2">
        <lista-unidades-select v-model="unidade"></lista-unidades-select>
      </div>
      <SelectComponentFerramenta
        @selectValue="injectFerramenta"
        :atualizar="atualizar"
        :resetar="resetar"
      />
      <Transition name="slide-fade">
        <q-card v-if="rightDrawerOpen" class="drawer-modal">
          <div class="row q-pa-md text-weight-bold">
            <div class="row col-12 items-center">
              <q-icon
                style="cursor: pointer"
                name="close"
                class="q-mr-md"
                size="22px"
                @click="rightDrawerOpen = false"
              />
              <span style="font-size: 16px">
                <span>
                  <span> Movimentar Status </span>
                </span>
              </span>
            </div>
          </div>
          <q-scroll-area class="teste" style="width: 100%; height: 92%">
            <div
              class="column col-12 justify-between no-wrap"
              style="height: 90%"
            >
              <div class="q-px-md text-weight-bold">
                <div class="col-md-12 q-mt-xs">
                  <div class="q-mb-xs">Ferramenta Nome</div>
                  <q-input disable dense outlined v-model="ferramenta.nome" />
                </div>
              </div>
              <div class="q-px-md text-weight-bold">
                <div class="col-md-12 q-mt-xs">
                  <div class="q-mb-xs">Status Atual</div>
                  <q-input disable dense outlined v-model="ferramenta.status" />
                </div>
              </div>
              <div class="q-px-md">
                <SelectComponentStatus
                  @selectValue="injectStatus"
                  :uuid="ferramenta.uuid"
                  :statusAtual="ferramenta.status"
                />
              </div>
            </div>
          </q-scroll-area>
        </q-card>
      </Transition>
    </q-page>
    <div
      v-if="rightDrawerOpen"
      @click="rightDrawerOpen = false"
      class="mascara"
    ></div>
  </div>
</template>

<script>
import SelectComponentFerramenta from "../components/SelectComponentFerramenta.vue";
import { ref, watch } from "vue";
import SelectComponentStatus from "../components/SelectComponentStatus.vue";
import ListaUnidadesSelect from "../../organizacional/unidade/component/ListaUnidadesSelect.vue";

import { useStore } from "vuex";
import PageHeader from "../../../components/PageHeader.vue";
//import { useQuasar } from "quasar";

// import { useRouter } from "vue-router";
export default {
  components: {
    SelectComponentFerramenta,
    SelectComponentStatus,
    ListaUnidadesSelect,
    PageHeader,
  },
  name: "CadastrarGrupo",
  setup() {
    const ferramenta = ref({
      uuid: "",
      nome: "",
      status: "",
    });
    const file = ref(null);
    const atualizar = ref(0);
    const resetar = ref(0);
    const unidade = ref();
    let rightDrawerOpen = ref(false);

    const atualizaLista = ref(false);
    //const $q = useQuasar();
    // const myForm = ref(null);
    const store = useStore();
    // const router = useRouter();

    let injectFerramenta = async (value) => {
      if (value.value.length == 0) {
        ferramenta.value.nome = "";
        ferramenta.value.status = "";
        ferramenta.value.uuid = "";
        return;
      }
      ferramenta.value.nome = value.value[0].nome;
      switch (value.value[0].status) {
        case "disponivel":
          ferramenta.value.status = "Disponível";
          break;
        case "manutencao":
          ferramenta.value.status = "Manutenção";
          break;
        case "uso":
          ferramenta.value.status = "Em Uso";
          break;
        case "manutencao_garantia":
          ferramenta.value.status = "Manutenção Garantia";
          break;
        case "removida":
          ferramenta.value.status = "Removida";
          break;
        case "reativacao":
          ferramenta.value.status = "Reativação";
          break;
        case "desmobilizada":
          ferramenta.value.status = "Desmobilizada";
          break;
        case "retorno_em_garantia":
          ferramenta.value.status = "Retorno em Garantia";
          break;
        case "descartada":
          ferramenta.value.status = "Descartada";
          break;
        case "furto":
          ferramenta.value.status = "Furto";
          break;
        case "sucata":
          ferramenta.value.status = "Sucata";
          break;
        case "aguardando_reparo":
          ferramenta.value.status = "Aguardando Reparo";
          break;
        case "calibracao":
          ferramenta.value.status = "Calibração";
          break;
        case "em_transito":
          ferramenta.value.status = "Em Trânsito";
          break;
        case "aguardando_calibracao":
          ferramenta.value.status = "Aguardando Calibração";
          break;
        default:
          break;
      }
      ferramenta.value.uuid = value.value[0].uuid;
    };

    let injectStatus = async (value) => {
      if (value.value === "") {
        return;
      }
      atualizar.value++;
      ferramenta.value.status = value.value;
      rightDrawerOpen.value = false;
    };

    watch(
      () => ferramenta.value.nome,
      () => {
        if (ferramenta.value.nome == "") {
          return;
        }
        rightDrawerOpen.value = true;
      }
    );

    watch(
      () => rightDrawerOpen.value,
      () => {
        if (rightDrawerOpen.value == false) {
          resetar.value++;
        }
      }
    );

    watch(
      () => store.state.org.unidadeData,
      () => {
        if (store.state.org.unidadeData == null) {
          return;
        }
        unidade.value = store.state.org.unidadeData;
      }
    );

    return {
      movimentaStatus: ref(false),
      atualizaLista,
      injectFerramenta,
      injectStatus,
      ferramenta,
      file,
      atualizar,
      rightDrawerOpen,
      resetar,
      unidade,
    };
  },
};
</script>

<style scoped>
a {
  text-decoration: none;
}

.comentarioUP {
  width: 100%;
  height: 40px;

  outline-color: #58afc1;
}
.container {
  height: 100%;
}
.animacao {
  transition: all 0.5s;
  cursor: pointer;
}
.animacao:hover {
  -webkit-transform: scale(1.1);
  -ms-transform: scale(1.1);
  transform: scale(1.1);
}
.drawer-modal {
  border: 2px solid black;
  position: absolute;
  right: 0;
  width: 450px;
  position: fixed;
  top: 106px;
  height: calc(100% - 10px);
  max-height: 650px;
  border-radius: 10px 1px 1px 10px;
  margin: 2px;
  z-index: 3;
  overflow: hidden;
}
.slide-fade-enter-active {
  transition: all 0.5s ease-out;
}
.slide-fade-leave-active {
  transition: all 0.5s cubic-bezier(1, 0.5, 0.8, 1);
}

.slide-fade-enter-from,
.slide-fade-leave-to {
  transform: translateX(400px);
}
.mascara {
  background-color: black;
  height: 100%;
  width: 100%;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 2;
  opacity: 0.4;
}
@media (max-width: 1200px) {
  .drawer-modal {
    max-height: 85%;
  }
}
@media (max-width: 900px) {
  .drawer-modal {
    max-height: 80%;
    top: 118px;
  }
}
@media (max-width: 600px) {
  .drawer-modal {
    max-height: 80%;
    top: 107px;
  }
}
</style>
